import { render, staticRenderFns } from "./DeveloperIndex.vue?vue&type=template&id=0b2466b1"
import script from "./DeveloperIndex.vue?vue&type=script&lang=js"
export * from "./DeveloperIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports